module.exports = __webpack_public_path__ + "img/quote-1-white.9335a60c.webp";